<section class="section white-100" *ngIf="ratingData">
  <div class="section-container-inside">
    <div class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="69440e5e1d2da56aaca47a91" data-style-height="24px" data-style-width="100%" data-token="b2f17544-4ecf-45a4-ae4d-2b194f342d3f">
      <a href="https://uk.trustpilot.com/review/verto.co" target="_blank" rel="noopener">Trustpilot</a>
    </div>
  </div>
</section>

<section class="section white-100" *ngIf="otherFeaturesData">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-32">
      {{ otherFeaturesData.title }}
    </h2>
    <p class="section-description mar-b-48 align-c">
      <span class="wid-75">
        {{ otherFeaturesData.desc }}
      </span>
    </p>
    <div class="section-explore-more">
      <ng-container *ngFor="let card of otherFeaturesData?.cards">
        <div class="explore-more">
          <div class="product-landing-content">
            <h5 class="explore-more-heading">
              <span [innerHtml]="card?.fields?.richTextTitle | toHtml"></span>
              <img
                loading="lazy"
                class="mar-l-8"
                src="{{ card?.fields?.iconImage?.fields?.file?.url }}"
                alt=""
              />
            </h5>
            <div
              class="product-landing-description"
              [innerHtml]="card?.fields?.description | toHtml"
            ></div>
          </div>
          <figure>
            <img
              loading="lazy"
              src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
              alt="{{ card?.fields?.imageicon?.fields?.title }}"
              class="product-landing-img"
            />
          </figure>
          <a class="explore-more-link" [href]="card?.fields?.link | urlParams:queryParams"></a>
        </div>
      </ng-container>
    </div>
  </div>
</section>
